import "./TestimonialCard.css"
import { FaStar } from "react-icons/fa"

const TestimonialCard = ({ name, age, image, testimonial, rating, country, flag }) => {
  // Generate stars based on rating
  const renderStars = () => {
    const stars = []
    for (let i = 0; i < 5; i++) {
      stars.push(<FaStar key={i} className={i < rating ? "star filled" : "star"} />)
    }
    return stars
  }

  return (
    <div className="testimonial-card">
      <div className="testimonial-content">
        <p className="testimonial-text">"{testimonial}"</p>
        <div className="testimonial-stars">{renderStars()}</div>
        <div className="testimonial-info">
          <h4>{name}</h4>
          <div className="testimonial-details">
            <div className="testimonial-flag">
              <span className="flag">{flag}</span> <span>From {country}</span>
            </div>
            <div className="testimonial-age">Age {age} Years</div>
          </div>
        </div>
      </div>
      <div className="testimonial-image">
        <img src={image || "/placeholder.svg"} alt={name} />
      </div>
    </div>
  )
}

export default TestimonialCard
